/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StorageDailyUploadStat { 
    /**
     * The upload date in YYYY-MM-DD format
     */
    uploadDate: Date;
    /**
     * The total number of files uploaded to the storage on the date specified
     */
    totalFiles?: number;
    /**
     * The total number of bytes uploaded to the storage on the date specified
     */
    totalBytes?: number;
}
